<template>
  <div v-if="status" v-tooltip.placementBottom="statusTooltip">
    <i
      v-if="status.reconciled"
      class="sf-c-success i-reconciled"
      data-testid="reconciled-icon"
    />
    <i
      v-if="!status.reconciled"
      class="sf-c-danger i-unreconciled"
      data-testid="unreconciled-icon"
    />
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { WorkflowOverviewItem } from '../types'
import { usePulseWorkflowProgress } from '@app/application/workflow-overview-navigation/store/pulse-workflow-progress'
import { storeToRefs } from 'pinia'
import { getPulseReconciliationStatusKey } from '../store/utils'

interface Props {
  item: WorkflowOverviewItem
}
const I18n = useI18n()
const props = defineProps<Props>()
const pulseWorkflowProgressStore = usePulseWorkflowProgress()
const { reconciliationStatuses } = storeToRefs(pulseWorkflowProgressStore)
const status = computed(
  () =>
    reconciliationStatuses.value[getPulseReconciliationStatusKey(props.item)]
)
const statusTooltip = computed(() => {
  return status.value.reconciled
    ? I18n.t('reconciliation_proposal.pulse.tooltip_reconciled')
    : I18n.t('reconciliation_proposal.pulse.tooltip_unreconciled')
})
</script>
